import { Box, Typography } from "@mui/material";
import useParamValues from "../../utils/useParamValues";
import useTranslationSetup from "../../utils/useTranslationSetup";
import "./styles.css";

const SubjectTag = () => {
  const { assessmentLang } = useParamValues();
  const { t } = useTranslationSetup();

  return (
    <Box className={`subject-tag-container ${assessmentLang}`}>
      <Typography className="subject-tag">
        {t(`${assessmentLang}-subject-tag`)}
      </Typography>
    </Box>
  );
};

export default SubjectTag;
